import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Briefcase, Users, Mail, Inbox } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ services: 0, team: 0, messages: 0, unread: 0 });

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Hizmet Alanları", value: stats.services, icon: Briefcase, to: "/admin/services" },
    { label: "Ekip Üyeleri", value: stats.team, icon: Users, to: "/admin/team" },
    { label: "Toplam Mesaj", value: stats.messages, icon: Mail, to: "/admin/messages" },
    { label: "Okunmamış", value: stats.unread, icon: Inbox, to: "/admin/messages" },
  ];

  return (
    <div data-testid="admin-dashboard" className="p-10">
      <div className="overline text-[#4A6A8F]">Genel Bakış</div>
      <h1 className="font-serif-ap text-5xl text-[#0F2746] mt-3">Yönetim Paneli</h1>
      <p className="text-[#3A5170] mt-3 max-w-xl">Site içeriğini buradan yönetin.</p>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.to}
            data-testid={`stat-${c.label}`}
            className="bg-white border border-[#0F2746]/10 p-7 hover:border-[#C4A47C] transition-colors group"
          >
            <div className="flex items-center justify-between">
              <c.icon size={20} className="text-[#4A6A8F]" />
              <span className="overline text-[10px] text-[#4A6A8F] group-hover:text-[#C4A47C]">→</span>
            </div>
            <div className="font-serif-ap text-5xl text-[#0F2746] mt-6">{c.value}</div>
            <div className="text-sm text-[#3A5170] mt-2">{c.label}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
